module.exports = __webpack_public_path__ + "static/media/img_Benchmarking206.de30ba3b.png";